import { MadoAccountUpdateInput } from '@libs/types/src/mado/input-type/account.update-input';
import { MadoAccountCreateInput } from '@libs/types/src/mado/input-type/account.create-input';
import { MadoAccountGridObject, MadoAccountObject } from '@libs/types/src/mado/object-type/account.object';
import { Injectable } from '@angular/core';
import { GridInput } from '@it2go/data-grid';
import { GqlServiceV2 } from '../../modules/content/service/gql.service-v2';
import { filterFrag } from '../types/filter.types';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';
import { madoAccountFrag } from '../types/mado-account.types';

@Injectable({ providedIn: 'root' })
export class MadoAccountServiceV2 extends GqlServiceV2 {

    public getMadoAccounts(input: GridInput | null = null, frag: string) {
        return this.query<MadoAccountGridObject>(
            `
                query($input: GridInput!) {
                    madoAccount {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createMadoAccount(input: MadoAccountCreateInput, frag = madoAccountFrag) {
        return this.mutate<MadoAccountObject>(
            `
                mutation($input: MadoAccountCreateInput!) {
                    madoAccount {
                        create(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateMadoAccount(input: MadoAccountUpdateInput, frag = madoAccountFrag) {
        return this.mutate<MadoAccountObject>(
            `
                mutation($input: MadoAccountUpdateInput!) {
                    madoAccount {
                        update(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteMadoAccount(input: IdInput, frag = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    madoAccount {
                        delete(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

}
